/* Plantica — Announcement bar

   One message at a time, moved by the two arrows and, if the merchant asks for
   it, by itself. It stops while the pointer is on the bar or while something
   inside it has keyboard focus — a line you are reading, or a link you are
   about to click, should not move out from under you.

   With `prefers-reduced-motion` nothing moves on its own: the arrows still
   work, so every message is still reachable.

   Without this file the bar shows its first message and nothing breaks.

   Custom file. See CUSTOMIZATIONS.md. */

(() => {
  if (customElements.get('plantica-announcement')) return;

  class PlanticaAnnouncement extends HTMLElement {
    connectedCallback() {
      this.items = [...this.querySelectorAll('.plantica-announce__item')];
      if (this.items.length < 2) return;

      this.index = this.items.findIndex((item) => item.classList.contains('is-current'));
      if (this.index < 0) this.index = 0;

      this.onPrev = () => this.step(-1, true);
      this.onNext = () => this.step(1, true);

      this.prevEl = this.querySelector('[data-announce-prev]');
      this.nextEl = this.querySelector('[data-announce-next]');
      if (this.prevEl) this.prevEl.addEventListener('click', this.onPrev);
      if (this.nextEl) this.nextEl.addEventListener('click', this.onNext);

      this.hold = this.stop.bind(this);
      this.release = this.play.bind(this);
      this.addEventListener('mouseenter', this.hold);
      this.addEventListener('mouseleave', this.release);
      this.addEventListener('focusin', this.hold);
      this.addEventListener('focusout', this.release);

      this.play();
    }

    disconnectedCallback() {
      this.stop();
      if (this.prevEl) this.prevEl.removeEventListener('click', this.onPrev);
      if (this.nextEl) this.nextEl.removeEventListener('click', this.onNext);
      this.removeEventListener('mouseenter', this.hold);
      this.removeEventListener('mouseleave', this.release);
      this.removeEventListener('focusin', this.hold);
      this.removeEventListener('focusout', this.release);
    }

    get wanted() {
      if (this.dataset.autoplay !== 'true') return false;
      return !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    }

    play() {
      this.stop();
      if (!this.wanted) return;

      const seconds = parseFloat(this.dataset.interval) || 5;
      this.timer = window.setInterval(() => this.step(1), seconds * 1000);
    }

    stop() {
      if (this.timer) window.clearInterval(this.timer);
      this.timer = null;
    }

    /* `byHand` restarts the clock: after someone presses an arrow, the next
       automatic change should be a whole interval away, not whatever was left
       of the one running. */
    step(direction, byHand) {
      const count = this.items.length;
      this.items[this.index].classList.remove('is-current');
      this.index = (this.index + direction + count) % count;
      this.items[this.index].classList.add('is-current');

      if (byHand && this.timer) this.play();
    }
  }

  customElements.define('plantica-announcement', PlanticaAnnouncement);
})();
